import type { BaseTranslation } from "../i18n-types.js"

const en = {
  migration: "Migration",
  myBonds: "My Bonds",
  oldWallet: "Old Wallet",
  bond: "Bond",
  network: "Network",
  date: "Date",
  status: "Status",
  continue: "Continue",
  learnMore: "learn more",
  later: "Later",
  comingSoon: "Coming Soon...",
  transactions: "Transactions",
  price: "Price",
  backToHome: "Back to Home",
  backToBonds: "Back to Bond List",
  cancel: "Cancel",
  retry: "Retry",
  notFound: "Not Found",
  pageError: "Unknow error, please try again",
  copyErrorDetail: "Copy error detail",
  timeoutError: "Request timeout, please try again",
  na: "N/A",
  auth: {
    authAndMigrate: "Authorization and Migration",
    tips: "We will not access your transaction history",
    title: "Mixin Asset Migration and Bond",
    desc: "Migrate assets from your old wallet to the new wallet while recording BTC, ETH, and USDT-ERC20 debts.",
    upgradeClient: "Upgrade Client",
    upgradeClientDesc: "The current client version is too low, please upgrade!",
    viewOldWallet: "View old wallet",
    checkPermissionOrUpgradeToSafe: "Please check all authorization or upgrade to Safe",
    failedToGetClientVersion: "Failed to get client version",
  },

  home: {
    title: "Mixin Asset Migration",
    empty: "No assets available for migration",
  },
  migrationsPage: {
    learnMoreUrl: "https://support.mixin.one/en/article/what-is-mdt-token-77n05i/",
    learnMoreBar: {
      title: "What is MDT? Tap to learn more.",
    },
    migrateID: "Migrate ID",
    pay: "Pay (Legacy Wallet)",
    receive: "Receive (New Wallet)",
    mixinSafeBond: "Mixin Safe Bond",
    bondPrice: "Bond Price",
    bondRatio: "Bond Ratio",
    migration: {
      title: "Migrate {symbol:string}",
      assetMigration: "Asset Migration",
      assetMigrationDesc: "You are migrating {amount:string} {symbol:string}, and after the migration is completed, your new wallet will automatically receive {received:string} {symbol:string}.",
      assetBondMigrationDesc:
        "You are migrating {amount:string} {symbol:string}, and after the migration is completed, your new wallet will automatically receive {received:string} {symbol:string}, and as a result, you will receive {bond:string} {mdtSymbol:string} bonds, learn more",
      boxBondMigrationDesc:
        "You are migrating {amount:string} {symbol:string}, and after the migration is completed, your new wallet will automatically receive {received:string} {symbol:string}, and as a result, you will receive {mdtbBond:string} MDTb and {mdteBond:string} MDTe bonds, learn more",
      agreeContinue: "Agree & Continue",
      migratedSuccessfully: "Migrated successfully",
      amount: "Amount",
    },
    records: {
      title: "Migration Records",
      migrated: "Migrated {amount:string} {symbol:string}",
      received: "Received {amount:string} {symbol:string}",
      receivedWithBond: "Received {amount:string} {symbol:string} and {bond:string} {mdtSymbol:string}",
    },
    detail: {
      title: "Migration Detail",
    },
  },
  bondsPage: {
    empty: "No bonds",
    total: "Total",
    getBond: "Get {mdtSymbol:string} bonds",
    date: {
      registered: "Registered: {date:string}",
      claimed: "Claimed: {date:string}",
    },
    detail: {
      title: "Bond Detail",
      bondId: "Bond ID",
      impairedAsset: "IMPAIRED_ASSET",
      registeredAt: "Registered Time",
      claimedAt: "Claimed Time",
      transactionAt: "Transaction Time",
    },
    receive: {
      title: "Claim MDT Bonds",
      desc: "You can claim {amount:string}. Select the card below and then click the claim button to claim the tokens. Read the documentation to learn more.",
      mdtToken: "MDT Token",
      mdtDesc: "Claim {mdts:string} bond tokens.",
      xinToken: "XIN Token",
      xinDesc: "Since your total debt is less than or equal to 100 MDT, you only have one chance to exchange it for XIN tokens at a fixed price of ${xinPrice:number}.",
      receive: "Claim",
      success: {
        title: "Claimed {symbol:string} token",
        xinDesc:
          "You have successfully exchanged {mdts:string} for {xin:string} XIN tokens at a fixed price of ${xinPrice:number}. The tokens will be transferred in batches according to the number and amount of your migrations. Please wait patiently while the transfers are queued.",
        mdtDesc:
          "You have successfully claimed {mdts:string} bond tokens. The tokens will be transferred in batches according to the number and amount of your migrations. Please wait patiently while the transfers are queued.",
        ok: "OK",
      },
      learnMoreUrl: "https://support.mixin.one/en/article/how-to-claim-mdt-token-18k55mf/",
    },
  },
} satisfies BaseTranslation

export default en
